export const heartAnimations = [
    {
        rotate: [-80, 333],
        y: [-200, 200, -200],
        x: [20, 0, -20],
        opacity: [0.7, 0, 1],
        scale: [1.4, 1, 1.4],
    },
    {
        rotate: [300, -42],
        y: [-400, -110, -400],
        x: [100, 0, -100],
        opacity: [0.55, 0, 1],
        scale: [4, 1, 4],
    },
    {
        rotate: [-200, 35],
        y: [-350, 20, -350],
        x: [-90, 0, 90],
        opacity: [0.7, 0, 1],
        scale: [1, 0.7, 1],
    },
    {
        rotate: [-230, 230],
        y: [-250, 20, -250],
        x: [250, 0, -250],
        opacity: [0.8, 0, 1],
        scale: [3.5, 0.5, 3.5],
    },
    {
        rotate: [-90, 90],
        y: [-100, 100, -100],
        x: [280, 0, -180],
        opacity: [0.75, 0, 1],
        scale: [2.5, 0.7, 2.5],
    },
    {
        rotate: [90, -90],
        y: [-250, 100, -210],
        x: [420, 0, -420],
        opacity: [0.9, 0, 1],
        scale: [2.5, 0.7, 2.5],
    },
    {
        rotate: [45, -135], // Unique rotation
        y: [-550, 50, -550], // Starts high, drops to 50, goes back up
        x: [600, 0, -600], // Moves from far right to left
        opacity: [0.8, 0, 0.9], // Fully visible → invisible → 90% visible
        scale: [2, 0.7, 2.5], // Scales up, then down, then back up
    },
    {
        rotate: [-90, 190],
        y: [-700, 100, -700],
        x: [-650, 0, 650],
        opacity: [0.7, 0, 1], // Slightly faded → invisible → fully visible
        scale: [2.3, 0.5, 2.8],
    },
    {
        rotate: [140, -200],
        y: [-400, 200, -400],
        x: [500, 0, -500],
        opacity: [0.4, 0, 0.8],
        scale: [3, 0.6, 3.5],
    },
    {
        rotate: [70, -70],
        y: [-420, 150, -420],
        x: [-550, 0, 550],
        opacity: [0.65, 0, 0.8],
        scale: [1.8, 0.9, 2.2],
    },
    {
        rotate: [180, -120],
        y: [180, 80, 180],
        x: [300, 0, -300],
        opacity: [0.3, 0, 0.7],
        scale: [2.5, 0.8, 3],
    },
    {
        rotate: [-45, 270],
        y: [300, 120, 300],
        x: [550, 0, -530],
        opacity: [0.7, 0, 0.7],
        scale: [2.2, 0.7, 2.6],
    },
    {
        rotate: [220, -40],
        y: [-640, 220, -640],
        x: [-300, 0, 300],
        opacity: [0.75, 0, 0.9],
        scale: [3.2, 0.4, 3.6],
    },
    {
        rotate: [-140, 140],
        y: [-20, 120, -20],
        x: [400, 0, -400],
        opacity: [0.51, 0, 0.5],
        scale: [2.7, 0.6, 3],
    },
]
